import posthog from "posthog-js";
import {
	ADIDAS_SHOPDOMAIN,
	CUSTOM_STORE,
	PARAMS_NAME,
	REACT_APP_ACCESS_KEY,
	REACT_APP_FITVIEW_CLIENT_URL,
	REACT_APP_SWAN_API_SERVER_URL,
	SCAN_STATUS,
	SCAN_TYPE,
	STORAGE_KEY,
} from "../services/constant";
import UseApiService from "../services/apiService";
import CustomMeasurementText from "../component/customMeasurementText/CustomMeasurementText";
import { jwtDecode } from "jwt-decode";
import ShowResultComponent from "../component/ShowResultComponent";
import swan from "../services/swanservice";
import axios from "axios";

export function getURLSearchParamsValue(url) {
	return new URLSearchParams(url);
}

export function setLocalStorage(key, value) {
	localStorage.setItem(key, value);
}

export function getLocalStorage(key) {
	return localStorage.getItem(key);
}
export function removeLocalStorage(key) {
	localStorage.removeItem(key);
}

export function getElementById(id) {
	return document.getElementById(id);
}

export async function userVerify(swanApiServerURL, token) {
	try {
		const res = await UseApiService.post({ url: `${swanApiServerURL}/auth/verify?token=${token}` });
		setLocalStorage(STORAGE_KEY.JWTToken, res?.data?.token);
	} catch (error) {
		console.log(error);
	}
}

export const getEndpointProductSupportBySwan = ({ productHandle, shopDomain }) => `${REACT_APP_SWAN_API_SERVER_URL}/customers/${shopDomain}/products/${productHandle}`;

export const getEndpointRecommendation = ({ productHandle, scanID, shopDomain }) => `${REACT_APP_SWAN_API_SERVER_URL}/recommendation/scan/${scanID}/shop/${shopDomain}/product/${productHandle}`;

export const getEndpointFitViewScan = ({ productHandle, shopDomain, shopifyRedirectUrl, callbackUrl,email }) => {
	let url = `${REACT_APP_FITVIEW_CLIENT_URL}?shop_domain=${shopDomain}&product_name=${productHandle}&shopify_redirect=${shopifyRedirectUrl}`;
	if (callbackUrl) {
		url += `&callback_url=${callbackUrl}`;
	}
	if (email) {
		url += `&email=${encodeURIComponent(email)}`;	
	}
	return url;
};

export const getEndpointFitViewCustomReScan = ({ productHandle, shopDomain, shopifyRedirectUrl, email, name, scanID, callbackUrl }) => {
	let url = `${REACT_APP_FITVIEW_CLIENT_URL}/rescan?shop_domain=${shopDomain}&product_name=${productHandle}&shopify_redirect=${shopifyRedirectUrl}&scan_type=clothing_custom_scan&scan_id=${scanID}`;
	if (email) {
		url += `&email=${encodeURIComponent(email)}`;
	}
	if (name) {
		url += `&name=${name}`;
	}
	if (callbackUrl) {
		url += `&callback_url=${callbackUrl}`;
	}
	return url;
};
export const getEndpointFitViewCustomScan = ({ productHandle, shopDomain, shopifyRedirectUrl, email, name, callbackUrl }) => {
	let url = `${REACT_APP_FITVIEW_CLIENT_URL}?shop_domain=${shopDomain}&shopify_redirect=${shopifyRedirectUrl}&scan_type=clothing_custom_scan`;
	if (email) {
		url += `&email=${encodeURIComponent(email)}`;
	}
	if (productHandle) {
		url+=`&product_name=${productHandle}`
	}
	if (name) {
		url += `&name=${name}`;
	}
	if (callbackUrl) {
		url += `&callback_url=${callbackUrl}`;
	}
	return url;
};
export async function checkTryOnAvailable({ email, shopDomain, productHandle }) {
	console.log("outside", { email, shopDomain, productHandle });

	if (checkIsToShowCaraousal({ shopDomain, email })) {
		console.log("inside", checkIsToShowCaraousal({ shopDomain, email }));
		return true;
	}
	if (!email || email === "null") throw new Error("Email does not exist, setting up new Try-On");
	try {
		const body = {
			url: `${REACT_APP_SWAN_API_SERVER_URL}/tryon/status`,
			params: {
				customerStoreUrl: shopDomain,
				productName: productHandle,
				userEmail: encodeURIComponent(email),
			},
		};
		const res = await UseApiService.get(body);
		const isAvailable = res?.data.tryonExists === true && res?.data.tryonStatus === "available";
		const status = isAvailable ? "success" : "failed";
		handleScanTimeCapture({ message: `${shopDomain}/try-on/shopify`, status, email });
		return isAvailable ? res?.data?.tryonId : false;
	} catch (error) {
		console.error(error, "while checking try-on availability");
		handleScanTimeCapture({ message: `${shopDomain}/try-on/shopify`, status: "failed", email });
		throw new Error(error);
	}
}

export async function fetchRecommendation({ productHandle, shopDomain, scanID }) {
	if (!scanID || scanID === "null") {
		throw new Error("scanID does not exist, setting up new scan");
	}
	try {
		const result = await swan.measurement.getMeasurementRecommendation({ scanId: scanID, shopDomain, productName: productHandle });
		handleScanTimeCapture({
			message: `${shopDomain}/measurement_success/shopify`,
			scanId: scanID,
			status: "success",
		});
		return result?.data?.size_recommendation;
	} catch (error) {
		console.error(error, "error");
		handleScanTimeCapture({
			message: `${shopDomain}/measurement_failed/shopify`,
			scanId: scanID,
			status: "failed",
		});
		throw new Error(error);
	}
}

export async function setupCTADisplay({ productHandle, isOnboadedTryon = false, isOnboadedRTW = false, email, shopDomain, scanID }) {
	let isTryonAvailable = false;
	let scanRes = false;
	console.log(`isOnboadedRTW:${isOnboadedRTW},isOnboadedTryon:${isOnboadedTryon}, checking onboarded`);
	if (isOnboadedTryon && isOnboadedRTW) {
		try {
			isTryonAvailable = await checkTryOnAvailable({ email, shopDomain, productHandle });
		} catch (error) {
			console.log(error);
		}
		try {
			scanRes = await checkCustomMeasurements({ scanID, isChecking: true });
		} catch (error) {
			console.log(error);
		}
	} else if (isOnboadedTryon && !isOnboadedRTW) {
		try {
			isTryonAvailable = await checkTryOnAvailable({ email, shopDomain, productHandle });
		} catch (error) {
			console.log(error);
		}
	} else if (!isOnboadedTryon && isOnboadedRTW) {
		try {
			scanRes = await checkCustomMeasurements({ scanID, isChecking: true });
		} catch (error) {
			console.log(error);
		}
	}
	if (isTryonAvailable || scanRes) {
		return (
			<ShowResultComponent
				isTryonAvailable={isTryonAvailable}
				scanRes={scanRes}
				scanType={getScanTYpe({ isOnboadedRTW, isOnboadedTryon })}
				productHandle={productHandle}
				shopDomain={shopDomain}
				scanID={scanID}
			/>
		);
	}
}

export function handleScanTimeCapture({ message, scanId, status, email }) {
	const timestamp = new Date().toISOString();
	let obj = {
		status,
		timestamp,
		email,
	};
	if (scanId) {
		obj = { ...obj, scanID: scanId };
	}
	posthog?.capture(message, obj);
}

export const storeSubscriptionCheck = async (storeName) => {
	try {
		const body = {
			url: `${REACT_APP_SWAN_API_SERVER_URL}/shopify/subscription`,
			params: {
				store_url: storeName,
			},
		};
		const res = await UseApiService.get(body);
		const { data } = res;
		if (data?.isTrialDemo) {
			return true;
		} else if (data?.isValid) {
			return data?.hasCustomAddon;
		}
		throw new Error("Store not subscribed");
	} catch (error) {
		throw new Error(error);
	}
};
export async function checkCustomMeasurements({ productHandle, shopDomain, shopifyRedirectUrl, email, name, scanID, callbackUrl, isChecking = false }) {
	if (scanID === "null" || !scanID) {
		throw new Error("scan Id not found ");
	}
	try {
		const body = {
			url: `${REACT_APP_SWAN_API_SERVER_URL}/measurements`,
			params: { scanId: scanID },
		};
		const res = await UseApiService.get(body);
		if (res?.data?.isMeasured) {
			if (CUSTOM_STORE[shopDomain]) {
				return <CustomMeasurementText link={getEndpointFitViewCustomReScan({ productHandle, shopDomain, shopifyRedirectUrl, email, name, scanID, callbackUrl })} />;
			} else {
				if (isChecking) {
					return SCAN_STATUS.FULLFILLED;
				}
				return <CustomMeasurementText />;
			}
		} else if (res?.data?.isMeasured === null) {
			if (isChecking) {
				return SCAN_STATUS.PENDING;
			}
			return <CustomMeasurementText isInProgress textToShow="Measurement Calculation in Progress." />;
		}
		removeLocalStorage(STORAGE_KEY.SCAN_ID);
		throw new Error(res?.data);
	} catch (error) {
		throw new Error(error);
	}
}
export const checkTokenValidity = (token, userEmail, shopDomain) => {
	try {
		const payload = jwtDecode(token);
		const { exp, email } = payload;
		const currentTime = Math.floor(Date.now() / 1000);
		let response = true;
		console.log(payload,"payload");
		
		if (!exp || currentTime > exp) {
			console.log("Token has expired.");
			response = false;
		}
		if (!email || email !== userEmail) {
			console.log("User email mismatch.");
			response = false;
		}
		if (!response) {
			removeLocalStorage(STORAGE_KEY.JWTToken);
		}
		return response;
	} catch (error) {
		console.error("Invalid token:", error.message);
		return false;
	}
};

export function clearLocalStorage() {
	removeLocalStorage(STORAGE_KEY.EMAIL);
	removeLocalStorage(STORAGE_KEY.JWTToken);
	removeLocalStorage(STORAGE_KEY.SCAN_ID);
}

export async function getUserDetails(userEmail,shopDomain) {
	const accessToken = getLocalStorage(STORAGE_KEY.JWTToken)
	if (!userEmail||!accessToken) {
		console.log("No userEmail or accessToken, skipping getUserDetails");
		return;
	}
	try {
		// API call to get user details
		const res = await axios.get(`${REACT_APP_SWAN_API_SERVER_URL}/user/profile`, {
			headers: {
			  Authorization: `Bearer ${accessToken}`
			}
		  })
		// const res = await swan.auth.getUserDetail(userEmail);
		const data = res.data;
		posthog?.capture(`${shopDomain}/userInfo`,{source:"shopify",data:JSON.stringify(data)})
		const isMeasured = data?.isMeasured;
		const isMuseGenerated = data?.isMuseGenerated;
		const scanId = data?.scanId;
		const faceScanId = data?.faceScanId;

		console.log("getUserDetails: ", { isMeasured, isMuseGenerated, scanId, faceScanId });

		// Case: isMeasured === null && isMuseGenerated === null
		if (isMeasured === null && isMuseGenerated === null) {
			if (scanId) {
				console.log("Case: isMeasured:null, isMuseGenerated:null, scanId present. Body scan in progress (loading screen)");
				setLocalStorage(STORAGE_KEY.SCAN_ID, scanId);
				removeLocalStorage(STORAGE_KEY.FACE_SCAN_ID);
			} else {
				console.log("Case: isMeasured:null, isMuseGenerated:null, scanId not present. Remove both IDs");
				removeLocalStorage(STORAGE_KEY.SCAN_ID);
				removeLocalStorage(STORAGE_KEY.FACE_SCAN_ID);
			}
			return;
		}

		// Case: isMeasured === false && isMuseGenerated === false
		if (isMeasured === false && isMuseGenerated === "failed") {
			console.log("Case: isMeasured:false, isMuseGenerated:false. Remove both IDs, user needs to do body scan then face scan");
			removeLocalStorage(STORAGE_KEY.SCAN_ID);
			removeLocalStorage(STORAGE_KEY.FACE_SCAN_ID);
			return;
		}

		// Case: isMeasured === null && isMuseGenerated === false
		if (isMeasured === null && isMuseGenerated === "failed") {
			console.log("Case: isMeasured:null, isMuseGenerated:false. Remove both IDs, redirect to face scan (body scan failed)");
			removeLocalStorage(STORAGE_KEY.SCAN_ID);
			removeLocalStorage(STORAGE_KEY.FACE_SCAN_ID);
			return;
		}

		// Case: isMeasured === false && isMuseGenerated === null
		if (isMeasured === false && isMuseGenerated === null) {
			console.log("Case: isMeasured:false, isMuseGenerated:null. Remove both IDs, redirect to body scan then face scan");
			removeLocalStorage(STORAGE_KEY.SCAN_ID);
			removeLocalStorage(STORAGE_KEY.FACE_SCAN_ID);
			return;
		}

		// Case: isMeasured === true && isMuseGenerated === null
		if (isMeasured === true && isMuseGenerated === null) {
			console.log("Case: isMeasured:true, isMuseGenerated:null. Save scanId, remove faceScanId, redirect to face scan");
			setLocalStorage(STORAGE_KEY.SCAN_ID, scanId);
			removeLocalStorage(STORAGE_KEY.FACE_SCAN_ID);
			return;
		}

		// Case: isMeasured === null && isMuseGenerated === true (rare, ignore)
		if (isMeasured === null && isMuseGenerated === "success") {
			console.log("Case: isMeasured:null, isMuseGenerated:true. Rare, ignore");
			return;
		}

		// Case: isMeasured === false && isMuseGenerated === true (rare, ignore)
		if (isMeasured === false && isMuseGenerated === "success") {
			console.log("Case: isMeasured:false, isMuseGenerated:true. Rare, ignore");
			return;
		}

		// Case: isMeasured === true && isMuseGenerated === false
		if (isMeasured === true && isMuseGenerated === "failed") {
			console.log("Case: isMeasured:true, isMuseGenerated:false. Save scanId, remove faceScanId, redirect to face scan");
			setLocalStorage(STORAGE_KEY.SCAN_ID, scanId);
			removeLocalStorage(STORAGE_KEY.FACE_SCAN_ID);
			return;
		}

		// Case: isMeasured === true && isMuseGenerated === true (normal happy path)
		if (isMeasured === true && isMuseGenerated === "success") {
			console.log("Case: isMeasured:true, isMuseGenerated:true. Save both scanId and faceScanId");
			setLocalStorage(STORAGE_KEY.SCAN_ID, scanId);
			setLocalStorage(STORAGE_KEY.FACE_SCAN_ID, faceScanId);
			return;
		}

		console.log("Case: Unhandled combination", { isMeasured, isMuseGenerated });
	} catch (error) {
		if (error.response && error.response.status === 404) {
			console.log("User not found (404), removing scanId and faceScanId");
			removeLocalStorage(STORAGE_KEY.SCAN_ID);
			removeLocalStorage(STORAGE_KEY.FACE_SCAN_ID);
		}
		console.log(error, "error while getting user details");
	}
}

export async function silentLogin({ email, userName, shopDomain  }) {
	console.log(email, userName, shopDomain, "silent");

	try {
		const body = {
			url: `${REACT_APP_SWAN_API_SERVER_URL}/auth/silent`,
			data: {
				email,
				userName,
				context: { shop_domain: shopDomain },
			},
			headers: {
				"X-Api-Key": REACT_APP_ACCESS_KEY,
			},
		};
		const res = await UseApiService.post(body);
		const data = res.data;
		if (data?.magicLinkToken) {
			setLocalStorage(STORAGE_KEY.EMAIL, email);
			setLocalStorage(STORAGE_KEY.JWTToken, data.magicLinkToken);
			// if (!scanId) {
				await getUserDetails(email,shopDomain);
			// }
		} else {
			throw new Error("Missing magicLinkToken in response");
		}
	} catch (error) {
		console.log(error, "while silent login");
		// clearLocalStorage(); // Clear local storage in case of error
	}
}

export const getScanTYpe = ({ isOnboadedRTW, isOnboadedTryon }) => {
	if (isOnboadedTryon && isOnboadedRTW) {
		return SCAN_TYPE.CLOTHING_SCAN_WITH_TRY_ON;
	} else if (isOnboadedRTW) {
		return SCAN_TYPE.CLOTHIN_SCAN_ONLY;
	} else if (isOnboadedTryon) {
		return SCAN_TYPE.CLOTHING_TRY_ON_ONLY;
	}
};

export const initializeAuth = async ({ email, name, shopDomain }) => {
	let jwtToken = getLocalStorage(STORAGE_KEY.JWTToken);
	if (jwtToken && checkTokenValidity(jwtToken, email, shopDomain)) {
		await getUserDetails(email,shopDomain);
	} else {
		if (email) {
			await silentLogin({ email, userName: name, shopDomain });
		}
	}
};
export const extractParams = (search) => {
	const params = new URLSearchParams(search);

	const safeGet = (key) => {
		const value = params.get(key);
		return value && value !== "null" ? value : null;
	};

	const scanId = safeGet(PARAMS_NAME.SCAN_ID);
	let email = safeGet(PARAMS_NAME.EMAIL);
	if (email) {
		email = decodeURIComponent(email).replace(/ /g, "+");
	}

	return {
		scanId,
		email,
		token: safeGet(PARAMS_NAME.TOKEN),
		fit: safeGet(PARAMS_NAME.FIT),
		cart: safeGet(PARAMS_NAME.CART),
	};
};
export const handleShareKit = async (url, shareText) => {
	if (!url) return;
	try {
		if (navigator.share) {
			await navigator.share({
				// title: "TryOn with Swan",
				text: shareText,
				// url: url,
			});
		}
	} catch (error) {
		console.log("Error sharing:", error);
	}
};

export const downloadImage = async (imageUrl, filename = "downloaded-image") => {
	try {
		const response = await fetch(imageUrl);
		const blob = await response.blob();
		const url = URL.createObjectURL(blob);
		const extension = imageUrl.split(".").pop()?.split("?")[0] || "png";
		const completeFilename = filename ? `${filename}.${extension}` : `downloaded-image.${extension}`;
		const link = document.createElement("a");
		link.href = url;
		link.download = completeFilename;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	} catch (error) {
		console.error("Error downloading image:", error);
	}
};

export const checkIsToShowCaraousal = ({ shopDomain }) => {
	// const slot = ADDIDAS_EMAILS.find((el)=>el?.email===email);
	if (shopDomain === ADIDAS_SHOPDOMAIN) {
		return true;
	}
	return null;
};
